import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import ActivitySearch from './activity-search/activity-search';
import ContentLoder from '@/components/cards/content-loader/content-loader';
import ComparativeSearch from './comparative-search/comparative-search';
import ComparativeContent from './comparative-search/comparative-content/comparative-content';

@Component({
    name: 'catalog-search',
    components: {
        'material-icon': GoogleMaterialIcon,
         ActivitySearch,
         ComparativeSearch,
         ComparativeContent,
         ContentLoder,
    },
})

export default class CatalogSearch extends Vue {

    // ------------------------------------------------------------------
    // Properties

    private get searchComponent() {
        return this.isComparativeSearch ? 'ComparativeSearch' : 'ActivitySearch';
    }

    private get contentComponent() {
        return this.isComparativeSearch ? 'ComparativeContent' : 'ContentLoder';
    }

    public isResource = false;

    private isComparativeSearch: boolean = false;

    private fileName: any = '';

    private fileId: any = null;

    private uploadType: any;

    private filterParams: any = {
        q: '*',
    };

    private parentChanged: any = '';

    public passRequestData() {
        window.location.href = `/catalog?type=my-content&&id=${this.fileId}&&uploadType=bulk-upload`;
      }

    public onClose() {
            window.location.href = `/catalog?type=my-content`;
    }

    public onBack(uploadType: any) {
        if (uploadType === 'bulk-upload') {
            window.location.href = `/catalog/my-content/bulk-upload`;
        } else {
            window.location.href = `/catalog/my-content/request-upload`;
        }
    }

    public onChangeActiveTab(activeTab: any) {
        this.isResource = activeTab.key === 'resource';
    }

    // -----------------------------------------------------------------------
    // Hooks
    private created() {
        this.$store.dispatch('activityStore/fetchCategory');
        const querParams = this.$route.query || {};
        this.fileName = querParams.filename;
        this.fileId = querParams.id;
        this.uploadType = querParams.uploadType;
    }

    // ---------------------------------------------------------------------------
    // Actions

    private switchSearch() {
        this.isComparativeSearch = !this.isComparativeSearch;
        this.$store.commit('comparativeStore/reset');
        this.filterParams = {
            q: '*',
        };
    }

    private comparativeSearch(params: string) {
        this.filterParams = params;
    }

    private onSelectTenantCard() {
        this.parentChanged = 'selectedTenantCard';
    }

}
